// 产品比较脚本 - 极简版
document.addEventListener("DOMContentLoaded", function () {
  // 获取移动产品选择器
  const mobileSelectLeft = document.getElementById("mobile-product-select-1");
  const mobileSelectRight = document.getElementById("mobile-product-select-2");
  const productData = window.productComparisonData?.products || [];
  
  // 创建通知容器
  const notificationContainer = createNotificationContainer();
  
  // 处理浏览器前进/后退导航问题
  window.addEventListener('pageshow', function(event) {
    // 如果页面是从缓存加载的，需要重新同步选择器和显示内容
    if (event.persisted) {
      syncMobileSelectors();
    }
  });
  
  // 初始化时同步选择器
  syncMobileSelectors();
  
  // 为移动端选择器添加事件监听
  if (mobileSelectLeft) {
    mobileSelectLeft.addEventListener("change", function() {
      updateMobileProductDisplay(this.value, 1);
    });
  }
  
  if (mobileSelectRight) {
    mobileSelectRight.addEventListener("change", function() {
      updateMobileProductDisplay(this.value, 2);
    });
  }
  
  // 同步移动端选择器和显示内容
  function syncMobileSelectors() {
    // 左侧产品选择器同步
    if (mobileSelectLeft && mobileSelectLeft.options.length > 1) {
      // 如果没有选中值，则默认选择第一个产品
      if (!mobileSelectLeft.value) {
        mobileSelectLeft.selectedIndex = 1;
      }
      // 确保显示内容与选择器一致
      updateMobileProductDisplay(mobileSelectLeft.value, 1);
    }
    
    // 右侧产品选择器同步
    if (mobileSelectRight && mobileSelectRight.options.length > 2) {
      // 如果没有选中值或选中值与左侧相同，则默认选择第二个产品
      if (!mobileSelectRight.value || mobileSelectRight.value === mobileSelectLeft.value) {
        mobileSelectRight.selectedIndex = 2;
      }
      // 确保显示内容与选择器一致
      updateMobileProductDisplay(mobileSelectRight.value, 2);
    }
  }
  
  // 更新移动端产品显示
  function updateMobileProductDisplay(productId, columnIndex) {
    if (!productId) return;
    
    // 检查是否选择了相同的产品
    if (columnIndex === 1 && mobileSelectRight && mobileSelectRight.value === productId) {
      showNotification("Cannot compare the same product.");
      mobileSelectLeft.selectedIndex = 0;
      return;
    }
    
    if (columnIndex === 2 && mobileSelectLeft && mobileSelectLeft.value === productId) {
      showNotification("Cannot compare the same product.");
      mobileSelectRight.selectedIndex = 0;
      return;
    }
    
    // 找到产品数据
    const product = findProduct(productId);
    if (!product) return;
    
    // 更新产品列内容
    const columnSelector = `.column-${columnIndex}`;
    
    // 更新产品图片和名称
    const productInfo = document.querySelector(`${columnSelector} .product-info`);
    if (productInfo) {
      const imageContainer = productInfo.querySelector('.product-image');
      if (imageContainer) {
        // 查找图片容器中的链接和图片元素
        let link = imageContainer.querySelector('a');
        
        // 确保链接元素存在
        if (link) {
          // 更新现有链接
          link.href = product.url;
          link.title = `View ${product.title}`;
          
          // 更新链接内的图片
          const image = link.querySelector('img');
          if (image) {
            image.src = product.image;
            image.alt = product.title;
          }
        }
      }
      
      const name = productInfo.querySelector('.product-name');
      if (name) name.textContent = product.title;
      
      const shopBtn = productInfo.querySelector('.shop-now-btn');
      if (shopBtn) shopBtn.href = product.url;
    }
    
    // 更新规格值
    const specCells = document.querySelectorAll(`${columnSelector} .spec-value`);
    specCells.forEach(cell => {
      const specKey = cell.getAttribute('data-spec');
      if (specKey && product.specs && product.specs[specKey]) {
        cell.textContent = product.specs[specKey];
      } else {
        cell.textContent = "-";
      }
    });
    
    // 添加数据属性记录当前显示的产品ID，用于状态检查
    const productColumn = document.querySelector(columnSelector);
    if (productColumn) {
      productColumn.setAttribute('data-current-product', productId);
    }
  }
  
  // 查找产品数据
  function findProduct(productId) {
    return productData.find(p => p.id === productId);
  }
  
  // 创建通知容器
  function createNotificationContainer() {
    const container = document.createElement("div");
    container.className = "comparison-notification-container";
    container.style.display = "none";
    container.style.position = "fixed";
    container.style.bottom = "20px";
    container.style.left = "50%";
    container.style.transform = "translateX(-50%)";
    container.style.backgroundColor = "#333";
    container.style.color = "#fff";
    container.style.padding = "10px 20px";
    container.style.borderRadius = "4px";
    container.style.boxShadow = "0 2px 10px rgba(0,0,0,0.2)";
    container.style.zIndex = "9999";
    
    document.body.appendChild(container);
    return container;
  }
  
  // 显示通知
  let notificationTimeout;
  function showNotification(message) {
    if (!notificationContainer) return;
    
    // 清除之前的超时
    if (notificationTimeout) {
      clearTimeout(notificationTimeout);
    }
    
    // 设置消息并显示
    notificationContainer.textContent = message;
    notificationContainer.style.display = "block";
    
    // 设置超时自动隐藏
    notificationTimeout = setTimeout(() => {
      notificationContainer.style.display = "none";
    }, 2000);
  }
});